new MutationObserver(() => {
    fixAccessibility();
}).observe(document.body, { childList: true, subtree: true });

fixAccessibility();

function fixAccessibility() {
    document.querySelectorAll('img:not([alt])').forEach(img => img.setAttribute('alt', ''));
    const element = document.querySelector('#boost-cart-app');
    if (element) {
        element.setAttribute('role', 'region');
        element.setAttribute('aria-label', 'Shopping cart');
    }
}